// CCI.js
import * as d3 from 'd3';

export const drawCCI = (svg, data, xScale, yScale, values, strokeColor) => {
    if (!values || !Array.isArray(values)) return;

    const validPoints = values.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    if (validPoints.length === 0) return;

    const lineGenerator = d3.line()
        .x(d => xScale(d.x))
        .y(d => yScale(d.y))
        .curve(d3.curveMonotoneX);

    // Color line based on value (red for extreme values)
    svg.append('path')
        .datum(validPoints)
        .attr('fill', 'none')
        .attr('stroke', strokeColor)
        .attr('stroke-width', 2)
        .attr('d', lineGenerator);
};